import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { createLoginOutbound } from '../../api/outbound/entryOutbounds';
import { createInitLobbyOutbound } from '../../api/outbound/lobbyOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { useAppSelector } from '../../redux/store';
export const RoomToLobbyTransitionScene = () => {
    const socketSend = useSocketSend();
    const loginString = useAppSelector((state) => state.gameEntry.loginString);
    useEffect(() => {
        if (!loginString) {
            throw new Error('loginString is not in redux store and is needed to transition from room to lobby');
        }
        socketSend(createLoginOutbound(loginString));
        socketSend(createInitLobbyOutbound());
    }, [socketSend, loginString]);
    return _jsx("div", {});
};
